import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Offcanvas,
  Container,
} from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import Logo from "public/img/logoWhite.png";
const Header = () => {
  const navigate = useNavigate();
  const [showCompany, setShowCompany] = useState(false);
  const [showCapabilities, setShowCapabilities] = useState(false);
  const [showAIML, setShowAIML] = useState(false);
  const [showIndustries, setShowIndustries] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showSolutions, setShowSolutions] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(location.pathname === "/");
  const [openSection, setOpenSection] = useState("AIML");
  const [openServiceSection, setOpenServiceSection] = useState("Solutions");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const toggleServiceSection = (section) => {
    if (openServiceSection !== section) {
      setOpenServiceSection(section);
    }
  };

  const [activeDropdown, setActiveDropdown] = useState(null);
  const handleMouseEnter = (index) => {
    setActiveDropdown(index);
  };
  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };
  const isDropdownActive = (index) => {
    return activeDropdown === index || (activeDropdown === null && index === 1);
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setIsHomePage(location.pathname === "/" && !isScrolled);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  const [activePage, setActivePage] = useState(null);
  // Declare your page paths here
  const pagePaths = [
    "/DigitalAgents",
    "/AIML",
    "/CRM",
    "/DigitalTransformation",
    "/CustomApplication",
    "/MobileApplication",
    "/Testing",
    "/Healthcare",
    "/Manufacturing",
    "/Mobility",
    "/Hospitality",
    "/Fashion",
    "/Education",
    "/Symbio",
    "/MetaHOS",
    "/LearningManagement",
    "/Verge",
    "/Startups",
    "/SMBs",
    "/EnterprisesCustomers",
    "/Contact",
  ];

  useEffect(() => {
    // Find the active page index
    const activePageIndex = pagePaths.findIndex((path) =>
      location.pathname.startsWith(path),
    );

    // Set the active page index in state
    setActivePage(activePageIndex);
  }, [location.pathname]);

  return (
    <>
      <header>
        <div className={`headerWrap ${isHomePage ? "homePageHeader" : ""}`}>
          <Navbar expand="md" className="" variant="light">
            <Container>
              <Navbar.Brand as={Link} to="/">
                <img
                  src="/img/logoWhite.png"
                  className="img-fluid"
                  alt="Hummingtec | AI/ML Consulting | IT Services | Software Development Company"
                />
                {/* <img
                  src={Logo}
                  className="img-fluid"
                  alt="Hummingtec | AI/ML Consulting | IT Services | Software Development Company"
                /> */}
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="offcanvasNavbar" />
              <Navbar.Offcanvas
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="start"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel">
                    Hummingtec | AI/ML Consulting | IT Services | Software
                    Development Company
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <NavDropdown
                      title={
                        <Nav.Link as={Link} to="/">
                          Company
                        </Nav.Link>
                      }
                      id="offcanvasNavbarDropdownFive"
                      className="megaMenu megaMenuOne bigMegaMenu"
                      show={showCompany}
                      onMouseEnter={() => setShowCompany(true)}
                      onMouseLeave={() => setShowCompany(false)}
                    >
                      <ul className="megaMenuCapabilities">
                        <li>
                          <Link className="mobDis martTop0px">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="20"
                              height="20"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="M141.05 8.787 49.837 100h91.213z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                                <circle
                                  cx="278.55"
                                  cy="97"
                                  r="15"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></circle>
                                <path
                                  d="M426.05 75.002V392c0 41.355-33.645 75-75 75h-235.1c0 24.813 20.187 45 45 45h265c24.813 0 45-20.187 45-45V120c0-24.78-20.133-44.943-44.9-44.998z"
                                  fill="#000000"
                                  opacity="0.45"
                                  data-original="#000000"
                                ></path>
                                <path
                                  d="M351.05 0h-180v115c0 8.284-6.716 15-15 15h-115v262c0 24.813 20.187 45 45 45h265c24.813 0 45-20.187 45-45V45c0-24.813-20.187-45-45-45zm-242.5 182h70c8.284 0 15 6.716 15 15s-6.716 15-15 15h-70c-8.284 0-15-6.716-15-15s6.716-15 15-15zm220 210h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-60h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-60h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15zm15-75c0 8.284-6.716 15-15 15h-100c-8.284 0-15-6.716-15-15v-20c0-22.315 11.306-42.035 28.488-53.745-5.333-7.396-8.488-16.461-8.488-26.255 0-24.813 20.187-45 45-45s45 20.187 45 45c0 9.794-3.155 18.86-8.488 26.255 17.181 11.71 28.488 31.43 28.488 53.745z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                                <path
                                  d="M278.55 142c-19.299 0-35 15.701-35 35v5h70v-5c0-19.299-15.701-35-35-35z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                              </g>
                            </svg>
                            About Us
                          </Link>
                          <ul>
                            <li>
                              <Link to="/AboutUs">Our Journey</Link>
                            </li>
                            <li>
                              <Link to="/AboutUs">Leadership</Link>
                            </li>
                            <li>
                              <Link to="/AboutUs">Mission & Vision</Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link className="mobDis">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="20"
                              height="20"
                              x="0"
                              y="0"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  d="m256.001 353.772 18.395-8.549v-75.619h-36.792v75.618z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                                <path
                                  d="M304.396 318.149v46.213l-48.394 22.492-48.398-22.491v-46.208L0 239.141v243.255h512V239.142z"
                                  fill="#000000"
                                  opacity="0.45"
                                  data-original="#000000"
                                ></path>
                                <path
                                  d="M207.604 286.056v-46.452h96.792v46.446L512 207.042V98.396H346.312V29.604H165.687v68.792H0v108.647zM195.687 59.604h120.625v38.792H195.687z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                              </g>
                            </svg>
                            Life At Hummingtec
                          </Link>
                          <ul>
                            <li>
                              <Link to="/Careers">Careers</Link>
                            </li>
                            {/* <li><Link to="/Internship">Internship</Link></li> */}
                          </ul>
                        </li>
                      </ul>
                    </NavDropdown>

                    <NavDropdown
                      title="Capabilities"
                      id="offcanvasNavbarDropdownOne"
                      className="megaMenu bigMegaMenu"
                      show={showCapabilities}
                      onMouseEnter={() => setShowCapabilities(true)}
                      onMouseLeave={() => setShowCapabilities(false)}
                    >
                      <div className="capabilities-grid">
                        {/* === LEFT COLUMN: MAIN MENU === */}
                        <ul
                          className="capabilities-menu"
                          data-open-section={openSection}
                        >
                          <li
                            className={`menu-header ${openSection === "AIML" ? "active-menu" : ""}`}
                            onMouseEnter={() =>
                              !isMobile && setOpenSection("AIML")
                            }
                            onClick={() => isMobile && toggleSection("AIML")}
                          >
                            <Link to="/AIML" className="icon-link">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 64 64"
                                >
                                  <g>
                                    <path
                                      d="M44.67 17.84c-4.08-3.65-9.35-5.33-14.84-4.72-8.94.99-15.99 8.23-16.76 17.2-.72 8.4 4.16 16.24 11.93 19.32v6.35c0 3.86 3.14 7 7 7s7-3.14 7-7v-6.35c7.21-2.86 12-9.86 12-17.65 0-5.4-2.31-10.56-6.33-14.16zm-7 30.17c-.4.14-.67.52-.67.94V50H27v-1.05c0-.42-.27-.8-.67-.94-7.3-2.58-11.93-9.79-11.27-17.52.69-8.03 6.99-14.5 14.99-15.39.66-.07 1.32-.11 1.97-.11 4.19 0 8.15 1.5 11.31 4.33 3.6 3.22 5.67 7.84 5.67 12.67C49 39.17 44.45 45.6 37.67 48zM33 11V6.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 0 0-5 0c0 1.02.62 1.9 1.5 2.29V11zM60 29.5c-1.02 0-1.9.62-2.29 1.5H53v2h4.71c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 0 0 0-5zM11 31H6.29c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 0 0 0 5c1.02 0 1.9-.62 2.29-1.5H11zM50.89 49.47l-3.33-3.33-1.41 1.41 3.33 3.33c-.35.9-.17 1.95.56 2.68.98.98 2.56.98 3.54 0s.98-2.56 0-3.54c-.72-.72-1.78-.91-2.68-.56zM13.97 10.43c-.98-.98-2.56-.98-3.54 0s-.98 2.56 0 3.54c.72.72 1.78.91 2.68.56l3.33 3.33 1.41-1.41-3.33-3.33c.35-.9.17-1.95-.56-2.68zM47.56 17.86l3.33-3.33c.9.35 1.95.17 2.68-.56.98-.98.98-2.56 0-3.54s-2.56-.98-3.54 0c-.72.72-.91 1.78-.56 2.68l-3.33 3.33 1.41 1.41zM16.44 46.14l-3.33 3.33c-.9-.35-1.95-.17-2.68.56-.98.98-.98 2.56 0 3.54s2.56.98 3.54 0c.72-.72.91-1.78.56-2.68l3.33-3.33-1.41-1.41z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="m28.3 29.5-.66 3h1.72l-.66-3z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M40 23H24c-2.21 0-4 1.79-4 4v10c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4V27c0-2.21-1.79-4-4-4zm-9.75 13.5-.44-2h-2.62l-.44 2H24.7l1.83-8.22c.1-.46.51-.78.98-.78h2c.47 0 .87.33.98.78l1.83 8.22h-2.05zm9.05-7h-1.5v5h1.5v2h-5v-2h1.5v-5h-1.5v-2h5z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              AI/ML
                            </Link>
                            <span className="arrow">
                              {openSection === "AIML" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>

                            {isMobile && openSection === "AIML" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/opticalCharRec">
                                    Optical Character Recognition
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/aiDrivenIn">
                                    AI-Driven Insights
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/generativeAi">Generative AI</Link>
                                </li>
                                <li>
                                  <Link to="/GPTModelTraining">
                                    GPT Model Training
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/AIChatbots">AI Chatbots</Link>
                                </li>
                                <li>
                                  <Link to="/leadGeneration">
                                    Lead Generation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/forecastingAndPrediction">
                                    Forecasting
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                          <li
                            className={`menu-header ${openSection === "DigitalTransformation" ? "active-menu" : ""}`}
                            onMouseEnter={() =>
                              !isMobile &&
                              setOpenSection("DigitalTransformation")
                            }
                            onClick={() =>
                              isMobile && toggleSection("DigitalTransformation")
                            }
                          >
                            <Link
                              to="/DigitalTransformation"
                              className="icon-link"
                            >
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 512 512"
                                >
                                  <g>
                                    <path
                                      d="M276.25 512.04h-42.86c-3.31 0-6-2.69-6-6v-52.62c-19.8-4.88-38.65-12.7-56.16-23.29L134 467.36a6.03 6.03 0 0 1-4.24 1.76c-1.6 0-3.12-.64-4.25-1.76L64.9 406.74a5.993 5.993 0 0 1 0-8.49l37.22-37.22a201.32 201.32 0 0 1-23.29-56.16H26.21c-3.31 0-6-2.69-6-6v-85.73c0-3.32 2.69-6 6-6h52.61c4.88-19.81 12.7-38.66 23.3-56.17L64.9 113.75a5.993 5.993 0 0 1-1.76-4.25c0-1.59.63-3.12 1.76-4.24l60.61-60.62c2.35-2.34 6.15-2.34 8.49 0l37.23 37.23c17.51-10.59 36.36-18.41 56.16-23.29V5.96c0-3.31 2.68-6 6-6h42.86c3.32 0 6 2.69 6 6v102.56c-199.62 9.37-199.62 285.59 0 294.96v102.56c0 3.32-2.68 6-6 6zm6-391.35v67.76h-44.11c-2.58-8.51-10.5-14.73-19.85-14.73-11.43 0-20.73 9.3-20.73 20.74 0 11.43 9.3 20.73 20.73 20.73 9.35 0 17.27-6.22 19.85-14.73h44.11v54.09h-52.83c-2.67-10.2-11.96-17.75-22.98-17.75-13.1 0-23.75 10.66-23.75 23.76 0 13.09 10.65 23.75 23.75 23.75 11.02 0 20.32-7.55 22.98-17.75h52.83v54.1h-44.11c-2.58-8.52-10.5-14.74-19.85-14.74-11.43 0-20.73 9.3-20.73 20.74 0 11.43 9.3 20.73 20.73 20.73 9.35 0 17.27-6.21 19.85-14.73h44.11v58.65c-184.32-12.04-184.32-258.58 0-270.62zm-64.06 139.86v.01c0 6.47-5.27 11.75-11.75 11.75s-11.75-5.28-11.75-11.75c0-6.48 5.27-11.75 11.75-11.75s11.75 5.27 11.75 11.74zm8.84 66.11c0 4.81-3.92 8.73-8.74 8.73-4.81 0-8.73-3.92-8.73-8.73 0-4.82 3.92-8.74 8.73-8.74 4.82 0 8.74 3.92 8.74 8.74z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 52.48h-78.13c-3.31 0-6-2.68-6-6 0-3.31 2.69-6 6-6h78.13c3.32 0 6.01 2.69 6.01 6a6 6 0 0 1-6.01 6zM354.38 471.52h-78.13c-3.31 0-6-2.69-6-6 0-3.32 2.69-6 6-6h78.13a6 6 0 0 1 6.01 6c0 3.31-2.69 6-6.01 6zM432.52 359.72h-78.14c-3.31 0-6-2.68-6-6 0-3.31 2.69-6 6-6h78.14c3.31 0 6 2.69 6 6 0 3.32-2.69 6-6 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 359.72c-3.31 0-6-2.68-6-6v-39.06c0-3.32 2.69-6 6-6 3.32 0 6 2.68 6 6v39.06c0 3.32-2.68 6-6 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 320.66h-78.13c-3.31 0-6-2.69-6-6 0-3.32 2.69-6 6-6h78.13a6 6 0 0 1 6.01 6c0 3.31-2.69 6-6.01 6zM459.15 386.36c-18 0-32.63-14.64-32.63-32.64 0-17.99 14.63-32.63 32.63-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM354.38 254.55h-78.13c-3.31 0-6-2.69-6-6s2.69-6 6-6h78.13c3.32 0 6.01 2.69 6.01 6s-2.69 6-6.01 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M381.02 281.19c-17.99 0-32.64-14.64-32.64-32.64 0-17.99 14.64-32.63 32.64-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM432.52 149.1h-78.14a6.005 6.005 0 0 1 0-12.01h78.14a6.005 6.005 0 0 1 0 12.01z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 188.16c-3.31 0-6-2.68-6-6V143.1c0-3.32 2.69-6 6-6 3.32 0 6 2.68 6 6v39.06c0 3.32-2.68 6-6 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 188.45h-78.13c-3.31 0-6-2.68-6-6 0-3.31 2.69-6 6-6h78.13c3.32 0 6.01 2.69 6.01 6a6 6 0 0 1-6.01 6zM459.15 175.73c-18 0-32.63-14.64-32.63-32.64 0-17.99 14.63-32.63 32.63-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM381.02 79.12c-17.99 0-32.64-14.64-32.64-32.64 0-17.99 14.64-32.63 32.64-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM381.02 498.15c-17.99 0-32.64-14.64-32.64-32.63 0-18 14.64-32.64 32.64-32.64s32.64 14.64 32.64 32.64c0 17.99-14.64 32.63-32.64 32.63zM209.56 194.46c0 4.81 3.92 8.73 8.73 8.73 4.82 0 8.74-3.92 8.74-8.73 0-4.82-3.92-8.74-8.74-8.74-4.81 0-8.73 3.92-8.73 8.74z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Digital Transformation
                            </Link>
                            <span className="arrow">
                              {openSection === "DigitalTransformation" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>

                            {isMobile &&
                              openSection === "DigitalTransformation" && (
                                <ul className="submenu">
                                  <li>
                                    <Link to="/websiteDevelopment">
                                      Website Development
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/CustomApplication">
                                      Custom Applications
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/MobileApplication">
                                      Mobile Applications
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/WorkflowAutomation">
                                      Workflow Automation
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/CloudAccessibility">
                                      Cloud Accessibility
                                    </Link>
                                  </li>
                                </ul>
                              )}
                          </li>
                          <li
                            className={`menu-header ${openSection === "DigitalMarketing" ? "active-menu" : ""}`}
                            onMouseEnter={() =>
                              !isMobile && setOpenSection("DigitalMarketing")
                            }
                            onClick={() =>
                              isMobile && toggleSection("DigitalMarketing")
                            }
                          >
                            <Link to="/DigitalMarketing" className="icon-link">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 512 512"
                                >
                                  <g>
                                    <path
                                      d="M276.25 512.04h-42.86c-3.31 0-6-2.69-6-6v-52.62c-19.8-4.88-38.65-12.7-56.16-23.29L134 467.36a6.03 6.03 0 0 1-4.24 1.76c-1.6 0-3.12-.64-4.25-1.76L64.9 406.74a5.993 5.993 0 0 1 0-8.49l37.22-37.22a201.32 201.32 0 0 1-23.29-56.16H26.21c-3.31 0-6-2.69-6-6v-85.73c0-3.32 2.69-6 6-6h52.61c4.88-19.81 12.7-38.66 23.3-56.17L64.9 113.75a5.993 5.993 0 0 1-1.76-4.25c0-1.59.63-3.12 1.76-4.24l60.61-60.62c2.35-2.34 6.15-2.34 8.49 0l37.23 37.23c17.51-10.59 36.36-18.41 56.16-23.29V5.96c0-3.31 2.68-6 6-6h42.86c3.32 0 6 2.69 6 6v102.56c-199.62 9.37-199.62 285.59 0 294.96v102.56c0 3.32-2.68 6-6 6zm6-391.35v67.76h-44.11c-2.58-8.51-10.5-14.73-19.85-14.73-11.43 0-20.73 9.3-20.73 20.74 0 11.43 9.3 20.73 20.73 20.73 9.35 0 17.27-6.22 19.85-14.73h44.11v54.09h-52.83c-2.67-10.2-11.96-17.75-22.98-17.75-13.1 0-23.75 10.66-23.75 23.76 0 13.09 10.65 23.75 23.75 23.75 11.02 0 20.32-7.55 22.98-17.75h52.83v54.1h-44.11c-2.58-8.52-10.5-14.74-19.85-14.74-11.43 0-20.73 9.3-20.73 20.74 0 11.43 9.3 20.73 20.73 20.73 9.35 0 17.27-6.21 19.85-14.73h44.11v58.65c-184.32-12.04-184.32-258.58 0-270.62zm-64.06 139.86v.01c0 6.47-5.27 11.75-11.75 11.75s-11.75-5.28-11.75-11.75c0-6.48 5.27-11.75 11.75-11.75s11.75 5.27 11.75 11.74zm8.84 66.11c0 4.81-3.92 8.73-8.74 8.73-4.81 0-8.73-3.92-8.73-8.73 0-4.82 3.92-8.74 8.73-8.74 4.82 0 8.74 3.92 8.74 8.74z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 52.48h-78.13c-3.31 0-6-2.68-6-6 0-3.31 2.69-6 6-6h78.13c3.32 0 6.01 2.69 6.01 6a6 6 0 0 1-6.01 6zM354.38 471.52h-78.13c-3.31 0-6-2.69-6-6 0-3.32 2.69-6 6-6h78.13a6 6 0 0 1 6.01 6c0 3.31-2.69 6-6.01 6zM432.52 359.72h-78.14c-3.31 0-6-2.68-6-6 0-3.31 2.69-6 6-6h78.14c3.31 0 6 2.69 6 6 0 3.32-2.69 6-6 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 359.72c-3.31 0-6-2.68-6-6v-39.06c0-3.32 2.69-6 6-6 3.32 0 6 2.68 6 6v39.06c0 3.32-2.68 6-6 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 320.66h-78.13c-3.31 0-6-2.69-6-6 0-3.32 2.69-6 6-6h78.13a6 6 0 0 1 6.01 6c0 3.31-2.69 6-6.01 6zM459.15 386.36c-18 0-32.63-14.64-32.63-32.64 0-17.99 14.63-32.63 32.63-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM354.38 254.55h-78.13c-3.31 0-6-2.69-6-6s2.69-6 6-6h78.13c3.32 0 6.01 2.69 6.01 6s-2.69 6-6.01 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M381.02 281.19c-17.99 0-32.64-14.64-32.64-32.64 0-17.99 14.64-32.63 32.64-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM432.52 149.1h-78.14a6.005 6.005 0 0 1 0-12.01h78.14a6.005 6.005 0 0 1 0 12.01z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 188.16c-3.31 0-6-2.68-6-6V143.1c0-3.32 2.69-6 6-6 3.32 0 6 2.68 6 6v39.06c0 3.32-2.68 6-6 6z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M354.38 188.45h-78.13c-3.31 0-6-2.68-6-6 0-3.31 2.69-6 6-6h78.13c3.32 0 6.01 2.69 6.01 6a6 6 0 0 1-6.01 6zM459.15 175.73c-18 0-32.63-14.64-32.63-32.64 0-17.99 14.63-32.63 32.63-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM381.02 79.12c-17.99 0-32.64-14.64-32.64-32.64 0-17.99 14.64-32.63 32.64-32.63s32.64 14.64 32.64 32.63c0 18-14.64 32.64-32.64 32.64zM381.02 498.15c-17.99 0-32.64-14.64-32.64-32.63 0-18 14.64-32.64 32.64-32.64s32.64 14.64 32.64 32.64c0 17.99-14.64 32.63-32.64 32.63zM209.56 194.46c0 4.81 3.92 8.73 8.73 8.73 4.82 0 8.74-3.92 8.74-8.73 0-4.82-3.92-8.74-8.74-8.74-4.81 0-8.73 3.92-8.73 8.74z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Digital Marketing
                            </Link>
                            <span className="arrow">
                              {openSection === "DigitalMarketing" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>

                            {isMobile && openSection === "DigitalMarketing" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/seo">SEO</Link>
                                </li>
                                <li>
                                  <Link to="/Sem">SEM</Link>
                                </li>
                                <li>
                                  <Link to="/SocialMediaManage">
                                    Social Media
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/EmailMarketing">
                                    Email Marketing
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                          <li
                            className={`menu-header ${openSection === "CRM" ? "active-menu" : ""}`}
                            onMouseEnter={() =>
                              !isMobile && setOpenSection("CRM")
                            }
                            onClick={() => isMobile && toggleSection("CRM")}
                          >
                            <Link to="/CRM" className="icon-link">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 512 512"
                                >
                                  <g>
                                    <path
                                      d="M189.38 76.14H0v-56c0-8.28 6.72-15 15-15h238.08l-23.42 46.11c-7.68 15.35-23.12 24.89-40.28 24.89z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M256 178.47a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95zm0 0a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95zM90 350.36v66.28h121v-66.28zm166-171.89a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95zm0 0a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95zM90 350.36v66.28h121v-66.28zM497 5.15H286.74l-30.29 59.61c-12.75 25.5-38.47 41.39-67.07 41.39H0v385.71c0 8.28 6.72 15 15 15h482c8.28 0 15-6.72 15-15V20.15c0-8.28-6.72-15-15-15zm-110 40c8.28 0 15 6.72 15 15s-6.72 15-15 15-15-6.72-15-15 6.72-15 15-15zm-74.27 216.67 18.26-101.16c.01-.05.02-.11.03-.17 1.49-7.73 8.02-13.5 15.88-14.03 7.85-.53 15.1 4.32 17.6 11.79.06.18.12.35.17.53L382 217.52l16.7-58.59c.05-.17.11-.35.16-.52 2.43-7.49 9.59-12.42 17.48-11.96 7.86.44 14.45 6.14 16.02 13.85l.03.18 19.34 101.19c1.56 8.14-3.78 16-11.91 17.55-8.14 1.56-16-3.78-17.55-11.92l-9.34-48.85-14.06 49.34c-.05.17-.11.35-.16.52a17.327 17.327 0 0 1-16.41 11.99h-.09c-7.47 0-14.07-4.74-16.45-11.83-.05-.17-.11-.35-.16-.53l-14.57-49.38-8.77 48.59c-1.48 8.16-9.28 13.56-17.43 12.1-8.15-1.47-13.57-9.27-12.1-17.43zm-185.79-115.4c13.41 0 26.36 3.95 37.44 11.44 6.86 4.64 8.67 13.96 4.03 20.83-4.64 6.86-13.96 8.67-20.83 4.03-6.1-4.12-13.23-6.3-20.64-6.3-20.37 0-36.94 16.57-36.94 36.94s16.57 36.94 36.94 36.94c7.44 0 13.68-2.19 18.53-6.52.95-.84 1.86-1.78 2.7-2.79 5.33-6.34 14.79-7.17 21.14-1.84 6.34 5.32 7.17 14.78 1.84 21.13-1.78 2.12-3.7 4.11-5.73 5.91-10.36 9.23-23.67 14.11-38.48 14.11-36.91 0-66.94-30.03-66.94-66.94s30.03-66.94 66.94-66.94zM241 431.64c0 8.28-6.72 15-15 15H75c-8.28 0-15-6.72-15-15v-96.28c0-8.28 6.72-15 15-15h151c8.28 0 15 6.72 15 15zm24.82-156.43-29.9-33.98v24.07c0 8.28-6.72 15-15 15-8.29 0-15-6.72-15-15V161.42c0-8.29 6.71-15 15-15h27.64c23.22-.235 43.712 18.678 43.52 42 0 17.92-11.7 33.25-28.12 39.27l24.38 27.7c5.48 6.22 4.87 15.7-1.35 21.17a14.923 14.923 0 0 1-9.9 3.74c-4.16 0-8.3-1.72-11.27-5.09zM452 431.64c0 8.28-6.72 15-15 15H286c-8.28 0-15-6.72-15-15v-96.28c0-8.28 6.72-15 15-15h151c8.28 0 15 6.72 15 15zm-5-356.49c-8.28 0-15-6.72-15-15s6.72-15 15-15 15 6.72 15 15-6.72 15-15 15zM301 416.64h121v-66.28H301zm-45-238.17a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95zM90 416.64h121v-66.28H90zm166-238.17a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95zm0 0a14.486 14.486 0 0 0-7.44-2.05H236c.01 4.83.04 19.42.06 24.03 4.73-.02 9.5-.04 12.5-.04 6.747.1 13.54-5.153 13.52-11.99 0-4.09-2.44-7.78-6.08-9.95z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Customer Relationship Management
                            </Link>
                            <span className="arrow">
                              {openSection === "CRM" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>
                            {isMobile && openSection === "CRM" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/salesforceCrm">Salesforce</Link>
                                </li>
                                <li>
                                  <Link to="/zohoCrm">Zoho</Link>
                                </li>
                                <li>
                                  <Link to="/CustomCrm">Custom CRM</Link>
                                </li>
                              </ul>
                            )}
                          </li>
                          <li
                            className={`menu-header ${openSection === "Testing" ? "active-menu" : ""}`}
                            onMouseEnter={() =>
                              !isMobile && setOpenSection("Testing")
                            }
                            onClick={() => isMobile && toggleSection("Testing")}
                          >
                            <Link to="/Testing" className="icon-link">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 512 512"
                                >
                                  <g>
                                    <path
                                      d="M375.5 274c-65.617 0-119 53.383-119 119s53.383 119 119 119c66.168 0 120-53.383 120-119s-53.832-119-120-119zm36.523 104.603-40 48a15.003 15.003 0 0 1-24.94-2.895l-16-32c-3.705-7.409-.701-16.42 6.708-20.124 7.409-3.707 16.42-.702 20.125 6.708l5.743 11.486 25.317-30.381c5.304-6.363 14.763-7.222 21.126-1.921 6.365 5.304 7.225 14.762 1.921 21.127z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="m369.035 85.453-60.862-62.939-.088-.091C294.072 8.173 274.573 0 254.59 0H61.5c-24.813 0-45 20.187-45 45v389c0 24.813 20.187 45 45 45h192.39c-17.243-24.312-27.39-53.992-27.39-86 0-82.159 66.841-149 149-149 5.062 0 10.065.254 15 .743V137.98c0-19.769-7.623-38.42-21.465-52.527zM175.5 335h-80c-8.284 0-15-6.716-15-15s6.716-15 15-15h80c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-80h-80c-8.284 0-15-6.716-15-15s6.716-15 15-15h80c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-80h-80c-8.284 0-15-6.716-15-15s6.716-15 15-15h80c8.284 0 15 6.716 15 15s-6.716 15-15 15zm96 80h-16c-8.284 0-15-6.716-15-15s6.716-15 15-15h16c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-80h-16c-8.284 0-15-6.716-15-15s6.716-15 15-15h16c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Security and Testing
                            </Link>
                            <span className="arrow">
                              {openSection === "CRM" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>
                            {isMobile && openSection === "Testing" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/SecurityTestingServices">
                                    Security Testing
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/HIPAACompliance">
                                    HIPAA Compliance
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                        </ul>

                        {/* === RIGHT COLUMN: SUBMENUS === */}
                        {!isMobile && (
                          <div
                            className="capabilities-submenu"
                            data-open-section={openSection}
                          >
                            {openSection === "AIML" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/opticalCharRec">
                                    Optical Character Recognition
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/aiDrivenIn">
                                    AI-Driven Insights For Competitive Edge
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/generativeAi">
                                    Generative AI In Garment Design
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/GPTModelTraining">
                                    GPT Model Training
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/AIChatbots">AI Chatbots</Link>
                                </li>
                                <li>
                                  <Link to="/leadGeneration">
                                    Lead Generation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/forecastingAndPrediction">
                                    AI Driven Forecasting And Prediction
                                  </Link>
                                </li>
                              </ul>
                            )}

                            {openSection === "DigitalTransformation" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/websiteDevelopment">
                                    Website Development
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/CustomApplication">
                                    Custom Application Development
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/MobileApplication">
                                    Mobile Application Development
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/ProcessDiscovery">
                                    Process Discovery & Digital Blueprinting
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/DataMigration">
                                    Data Migration & Task Automation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/WorkflowAutomation">
                                    Workflow Automation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/RealTimeDashboards">
                                    Real-Time Dashboards & Reporting
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/AIPoweredForecasting">
                                    AI-Powered Forecasting
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/CloudAccessibility">
                                    Cloud Accessibility
                                  </Link>
                                </li>
                              </ul>
                            )}

                            {openSection === "DigitalMarketing" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/seo">
                                    Search Engine Optimization
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/Sem">Search Engine Marketing</Link>
                                </li>
                                <li>
                                  <Link to="/SocialMediaManage">
                                    Social Media Marketing
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/cms">
                                    Content Management System
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/ContentMarketing">
                                    Content Marketing
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/EmailMarketing">
                                    Email Marketing & Automation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/Cro">
                                    Conversion Rate Optimization
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/WorkflowAutomation">
                                    Web Analytics & Reporting
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/Orm">
                                    Online Reputation Management
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/CustomerEngagement">
                                    Customer Engagement
                                  </Link>
                                </li>
                              </ul>
                            )}

                            {openSection === "CRM" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/salesforceCrm">
                                    Salesforce CRM
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/zohoCrm">Zoho CRM</Link>
                                </li>
                                <li>
                                  <Link to="/CustomCrm">Custom CRM</Link>
                                </li>
                              </ul>
                            )}

                            {openSection === "Testing" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/HIPAACompliance">
                                    HIPAA Compliance & IT Security Solutions
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/IoTSecurityTestingServices">
                                    IoT Security Testing Services
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/SecurityTestingServices">
                                    Security Testing Services
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </div>
                        )}
                      </div>
                    </NavDropdown>

                    <NavDropdown
                      title="Industries"
                      id="offcanvasNavbarDropdownTwo"
                      show={showIndustries}
                      onMouseEnter={() => setShowIndustries(true)}
                      onMouseLeave={() => setShowIndustries(false)}
                    >
                      <NavDropdown.Item as={Link} to="/Healthcare">
                        Healthcare
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Manufacturing">
                        Manufacturing
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Mobility">
                        Mobility
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Hospitality">
                        Hospitality
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Construction">
                        Construction
                      </NavDropdown.Item>
                      {/* <NavDropdown.Item as={Link} to="/Fashion">Fashion</NavDropdown.Item> */}
                      <NavDropdown.Item as={Link} to="/Education">
                        Education
                      </NavDropdown.Item>
                    </NavDropdown>

                    <NavDropdown
                      title="Products"
                      id="offcanvasNavbarDropdownThree"
                      show={showProducts}
                      onMouseEnter={() => setShowProducts(true)}
                      onMouseLeave={() => setShowProducts(false)}
                    >
                      {/* <NavDropdown.Item as={Link} to="/Symbio">Symbio</NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/MetaHOS">Metahos</NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/LearningManagement">Learning Management</NavDropdown.Item> */}
                      <NavDropdown.Item
                        as={Link}
                        to="/IntelligentChatAutomation"
                      >
                        Intelligent Chat Automation
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/AIDrivenEComSolutions">
                        E-Commerce Solutions
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/AIPoweredAppBooking">
                        Appointment Booking Solution
                      </NavDropdown.Item>
                    </NavDropdown>

                    <NavDropdown
                      title="Services"
                      id="offcanvasNavbarDropdownFour"
                      className="megaMenu megaMenuSm bigMegaMenu"
                      show={showServices}
                      onMouseEnter={() => setShowServices(true)}
                      onMouseLeave={() => setShowServices(false)}
                    >
                      <div className="capabilities-grid">
                        {/* === LEFT COLUMN: MAIN MENU === */}
                        <ul
                          className="capabilities-menu"
                          data-open-section={openServiceSection}
                        >
                          <li
                            className={`menu-header ${
                              openServiceSection === "Solutions"
                                ? "active-menu"
                                : ""
                            }`}
                            onMouseEnter={() =>
                              !isMobile && setOpenServiceSection("Solutions")
                            }
                            onClick={() =>
                              isMobile && setOpenServiceSection("Solutions")
                            }
                          >
                            <Link to="/Startups" className="mobDis">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 32 32"
                                >
                                  <g>
                                    <path
                                      d="M17 6c0 .55-.45 1-1 1h-3.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H16c.55 0 1 .45 1 1v4h3v-2.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5V15h4V5c0-2.21-1.79-4-4-4H17z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M6 15c.55 0 1 .45 1 1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V16c0-.55.45-1 1-1h4v-3h-2.5C10.57 12 9 10.43 9 8.5S10.57 5 12.5 5H15V1H5C2.79 1 1 2.79 1 5v10z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M15 26c0-.55.45-1 1-1h3.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16c-.55 0-1-.45-1-1v-4h-3v2.5c0 1.93-1.57 3.5-3.5 3.5S5 21.43 5 19.5V17H1v10c0 2.21 1.79 4 4 4h10z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M26 17c-.55 0-1-.45-1-1v-3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V16c0 .55-.45 1-1 1h-4v3h2.5c1.93 0 3.5 1.57 3.5 3.5S21.43 27 19.5 27H17v4h10c2.21 0 4-1.79 4-4V17z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Solutions
                            </Link>
                            <span className="arrow">
                              {openServiceSection === "Solutions" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>
                            {isMobile && openServiceSection === "Solutions" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/Startups">Startups</Link>
                                </li>
                                <li>
                                  <Link to="/SMBs">SMBs</Link>
                                </li>
                                <li>
                                  <Link to="/EnterprisesCustomers">
                                    Enterprise Customers
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                          <li
                            className={`menu-header ${
                              openServiceSection === "Development"
                                ? "active-menu"
                                : ""
                            }`}
                            onMouseEnter={() =>
                              !isMobile && setOpenServiceSection("Development")
                            }
                            onClick={() =>
                              isMobile && setOpenServiceSection("Development")
                            }
                          >
                            <Link to="/ReactJs" className="mobDis">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="512"
                                  height="512"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 66 66"
                                >
                                  <g>
                                    <path
                                      d="M64 14.92V4.59A2.59 2.59 0 0 0 61.41 2H4.59A2.59 2.59 0 0 0 2 4.59v10.33zM31.71 5.88a2.58 2.58 0 1 1 0 5.16 2.58 2.58 0 0 1 0-5.16zm-10.33 0a2.58 2.58 0 1 1 0 5.16 2.58 2.58 0 0 1 0-5.16zm-10.34 0a2.58 2.58 0 1 1 0 5.16 2.58 2.58 0 0 1 0-5.16zM11.04 52.37h43.91V26.54H11.04zm30.52-18.33a1.294 1.294 0 1 1 1.54-2.08l8.75 6.46c.33.24.52.63.52 1.04s-.19.8-.52 1.04l-8.75 6.46c-.88.49-1.55.07-1.81-.27-.42-.57-.3-1.38.27-1.81l7.34-5.42zM27.97 46.63l7.75-15.5c.32-.64 1.09-.89 1.73-.58.64.32.9 1.09.58 1.73l-7.75 15.5c-.39 1.09-1.55.67-1.73.58-.64-.32-.9-1.09-.58-1.73zm-13.82-8.21 8.75-6.46c.57-.42 1.38-.3 1.81.27.42.57.3 1.38-.27 1.81l-7.35 5.42 7.35 5.42c.57.42.7 1.23.27 1.81-.25.34-.92.82-1.81.27l-8.75-6.46c-.33-.24-.52-.63-.52-1.04s.19-.8.52-1.04z"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M2 17.5v43.91A2.59 2.59 0 0 0 4.59 64h56.83A2.58 2.58 0 0 0 64 61.42V17.5zm55.54 36.16c0 .71-.58 1.29-1.29 1.29H9.75c-.71 0-1.29-.58-1.29-1.29V25.25c0-.71.58-1.29 1.29-1.29h46.5c.71 0 1.29.58 1.29 1.29z"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Development Services
                            </Link>
                            <span className="arrow">
                              {openServiceSection === "Development" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>

                            {isMobile &&
                              openServiceSection === "Development" && (
                                <ul className="submenu">
                                  <li>
                                    <Link to="/ReactJs">React.js</Link>
                                  </li>
                                  <li>
                                    <Link to="/Python">Python</Link>
                                  </li>
                                  <li>
                                    <Link to="/NodeJs">Node.js</Link>
                                  </li>
                                  <li>
                                    <Link to="/DotNET">.NET</Link>
                                  </li>
                                  <li>
                                    <Link to="/Java">Java</Link>
                                  </li>
                                  <li>
                                    <Link to="/PHP">PHP</Link>
                                  </li>
                                  <li>
                                    <Link to="/Angular">Angular</Link>
                                  </li>
                                </ul>
                              )}
                          </li>
                          <li
                            className={`menu-header ${
                              openServiceSection === "Staff"
                                ? "active-menu"
                                : ""
                            }`}
                            onMouseEnter={() =>
                              !isMobile && setOpenServiceSection("Staff")
                            }
                            onClick={() =>
                              isMobile && setOpenServiceSection("Staff")
                            }
                          >
                            <Link to="/StaffAugmentation" className="mobDis">
                              <span className="icon">
                                {" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 512 512"
                                >
                                  <g>
                                    <path
                                      d="M256 202.5c-53.762 0-97.5 43.738-97.5 97.5v60h195v-60c0-53.762-43.738-97.5-97.5-97.5zM323.5 135c0-37.223-30.277-67.5-67.5-67.5s-67.5 30.277-67.5 67.5 30.277 67.5 67.5 67.5 67.5-30.277 67.5-67.5zM166 67.5C166 30.277 135.723 0 98.5 0S31 30.277 31 67.5 61.277 135 98.5 135 166 104.723 166 67.5zM413.5 135c-39.625 0-73.66 23.852-88.895 57.875C359.922 215.57 383.5 254.996 383.5 300H512v-67.5c0-53.762-44.738-97.5-98.5-97.5zM481 67.5C481 30.277 450.723 0 413.5 0S346 30.277 346 67.5s30.277 67.5 67.5 67.5S481 104.723 481 67.5zm0 0"
                                      fill="#000000"
                                      opacity="1"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M187.395 192.875C172.16 158.852 138.125 135 98.5 135 44.738 135 0 178.738 0 232.5V300h128.5c0-45.004 23.578-84.43 58.895-107.125zm0 0"
                                      fill="#000000"
                                      opacity="0.45"
                                      data-original="#000000"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Staff Augmentation
                            </Link>
                            <span className="arrow">
                              {openServiceSection === "Staff" ? (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5999 7.45833L11.1666 12.8917C10.5249 13.5333 9.4749 13.5333 8.83324 12.8917L3.3999 7.45833"
                                    stroke="black"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>
                            {isMobile && openServiceSection === "Staff" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/StaffAugmentation">
                                    Staff Augmentation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/DedicatedTeams">
                                    Dedicated Teams
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                          <li>
                            <Link to="/Pricing" className="icon-link">
                              <span className="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  width="20"
                                  height="20"
                                  x="0"
                                  y="0"
                                  viewBox="0 0 512 512.001"
                                >
                                  <g>
                                    <path
                                      d="M266.438 104.96h56.519l-86.508-91.003v60.898c0 16.497 13.38 30.106 29.988 30.106Zm0 0"
                                      fill="#000000"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M172.668 334.488H72.434c-5.075 0-9.227-4.148-9.227-9.226 0-5.075 4.152-9.227 9.227-9.227H178.78c5.88-14.992 13.723-27.683 23.414-40.37H72.434c-5.075 0-9.227-4.15-9.227-9.228 0-5.074 4.152-9.226 9.227-9.226h147.293c27.68-24.223 64.359-39.676 104.382-39.676 3.805 0 6.922.344 11.536.692v-94.813h-69.207c-26.758 0-48.442-21.914-48.442-48.559V0H41.062C18.223 0 0 18.684 0 41.637V393.66c0 22.953 18.223 41.176 41.063 41.176h138.984c-7.957-18.453-12.34-39.215-12.34-60.899-.117-13.609 1.73-26.761 4.961-39.449ZM72.434 199.54h116.843c5.075 0 9.227 4.152 9.227 9.23 0 5.075-4.152 9.227-9.227 9.227H72.434c-5.075 0-9.227-4.152-9.227-9.226 0-5.079 4.152-9.23 9.227-9.23Zm0 0"
                                      fill="#000000"
                                      data-original="#000000"
                                    ></path>
                                    <path
                                      d="M323.992 236.336c-76.008 0-137.832 61.82-137.832 137.832C186.16 450.176 247.984 512 323.992 512c76.012 0 137.836-61.824 137.836-137.832 0-76.012-61.824-137.832-137.836-137.832Zm-.226 127.914c27.796 0 50.285 22.605 50.285 50.285 0 24.914-18.106 45.563-41.867 49.598v13.379c0 5.078-4.153 9.23-9.227 9.23-5.074 0-9.227-4.152-9.227-9.23v-13.723c-22.953-4.73-40.253-25.031-40.253-49.254 0-5.074 4.152-9.226 9.226-9.226 5.074 0 9.227 4.152 9.227 9.226 0 17.535 14.304 31.836 31.836 31.836 17.53 0 31.832-14.305 31.832-31.836s-14.301-31.832-31.832-31.832c-27.797 0-50.29-22.61-50.29-50.289 0-24.34 17.301-44.637 40.254-49.25v-9.805c0-5.078 4.153-9.23 9.227-9.23 5.074 0 9.227 4.152 9.227 9.23v9.34c23.761 4.04 41.867 24.684 41.867 49.598 0 5.074-4.149 9.226-9.227 9.226-5.074 0-9.226-4.152-9.226-9.226 0-16.84-13.149-30.68-29.758-31.832-.922.344-1.961.46-3 .46-.922 0-1.73-.116-2.652-.347-15.918 1.73-28.372 15.227-28.372 31.719.114 17.648 14.414 31.953 31.95 31.953Zm0 0"
                                      fill="#000000"
                                      data-original="#000000"
                                      opacity="0.45"
                                    ></path>
                                  </g>
                                </svg>
                              </span>{" "}
                              Pricing
                            </Link>
                          </li>
                        </ul>

                        {/* === RIGHT COLUMN: SUBMENUS === */}
                        {!isMobile && (
                          <div
                            className="capabilities-submenu"
                            data-open-section={openServiceSection}
                          >
                            {openServiceSection === "Solutions" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/Startups">Startups</Link>
                                </li>
                                <li>
                                  <Link to="/SMBs">SMBs</Link>
                                </li>
                                <li>
                                  <Link to="/EnterprisesCustomers">
                                    Enterprise Customers
                                  </Link>
                                </li>
                              </ul>
                            )}

                            {openServiceSection === "Development" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/ReactJs">React.js</Link>
                                </li>
                                <li>
                                  <Link to="/Python">Python</Link>
                                </li>
                                <li>
                                  <Link to="/NodeJs">Node.js</Link>
                                </li>
                                <li>
                                  <Link to="/DotNET">.NET</Link>
                                </li>
                                <li>
                                  <Link to="/Java">Java</Link>
                                </li>
                                <li>
                                  <Link to="/PHP">PHP</Link>
                                </li>
                                <li>
                                  <Link to="/Angular">Angular</Link>
                                </li>
                              </ul>
                            )}

                            {openServiceSection === "Staff" && (
                              <ul className="submenu">
                                <li>
                                  <Link to="/StaffAugmentation">
                                    Staff Augmentation
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/DedicatedTeams">
                                    Dedicated Teams
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </div>
                        )}
                      </div>
                    </NavDropdown>

                    <Nav.Link
                      as={Link}
                      to="/Contact"
                      className={
                        activePage === pagePaths.length - 1 ? "active" : ""
                      }
                    >
                      Contact Us
                    </Nav.Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        </div>
      </header>
    </>
  );
};
export default Header;
